<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>image</mat-icon></div>
          <mat-card-title>Banners</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"
          [showSituacao]="true"
          [(situacao)]="situacao"
          (consultar)="consultar()"
          (novo)="novo()">
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Informe os filtros e clique em <strong>Consultar</strong>.
        </div>

        <ng-container *ngIf="consultaRealizada">
          <table mat-table [dataSource]="banners" class="full-width">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let banner">{{ banner.id }}</td>
            </ng-container>
            <ng-container matColumnDef="descricao">
              <th mat-header-cell *matHeaderCellDef>Descrição</th>
              <td mat-cell *matCellDef="let banner">{{ banner.descricao }}</td>
            </ng-container>
            <ng-container matColumnDef="dataInicio">
              <th mat-header-cell *matHeaderCellDef>Data de Início</th>
              <td mat-cell *matCellDef="let banner">{{ banner.dataInicio }}</td>
            </ng-container>
            <ng-container matColumnDef="dataTermino">
              <th mat-header-cell *matHeaderCellDef>Data de Término</th>
              <td mat-cell *matCellDef="let banner">{{ banner.dataTermino }}</td>
            </ng-container>
            <ng-container matColumnDef="nomeArquivo">
              <th mat-header-cell *matHeaderCellDef>Nome do Arquivo</th>
              <td mat-cell *matCellDef="let banner">{{ banner.nomeArquivo }}</td>
            </ng-container>
            <ng-container matColumnDef="ativo">
              <th mat-header-cell *matHeaderCellDef>Ativo</th>
              <td mat-cell *matCellDef="let banner">{{ banner.ativo ? 'Sim' : 'Não' }}</td>
            </ng-container>
            <ng-container matColumnDef="acoes">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let banner" (click)="$event.stopPropagation()">
                <button mat-icon-button color="accent" matTooltip="Editar" (click)="editar(banner.id)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" matTooltip="Excluir" (click)="deletar(banner.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
            <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
              (click)="editar(row.id)"></tr>
          </table>

          <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
            [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
          </mat-paginator>
        </ng-container>
      </mat-card>
    </div>
  </div>
</main>
